/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { BaseResponse } from '../models/base-response';
import { commonControllerFindCountries } from '../fn/common/common-controller-find-countries';
import { CommonControllerFindCountries$Params } from '../fn/common/common-controller-find-countries';
import { commonControllerFindRoles } from '../fn/common/common-controller-find-roles';
import { CommonControllerFindRoles$Params } from '../fn/common/common-controller-find-roles';
import { CountryResponse } from '../models/country-response';
import { UserRoleListResponse } from '../models/user-role-list-response';

@Injectable({ providedIn: 'root' })
export class CommonService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `commonControllerFindRoles()` */
  static readonly CommonControllerFindRolesPath = '/common/roles';

  /**
   * Restituisce l'elenco dei ruoli.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerFindRoles()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerFindRoles$Response(params?: CommonControllerFindRoles$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: UserRoleListResponse;
}>> {
    const obs = commonControllerFindRoles(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce l'elenco dei ruoli.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerFindRoles$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerFindRoles(params?: CommonControllerFindRoles$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: UserRoleListResponse;
}> {
    const resp = this.commonControllerFindRoles$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: UserRoleListResponse;
}>): BaseResponse & {
'data'?: UserRoleListResponse;
} => r.body)
    );
  }

  /** Path part for operation `commonControllerFindCountries()` */
  static readonly CommonControllerFindCountriesPath = '/common/countries';

  /**
   * Restituisce l'elenco dei paesi.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `commonControllerFindCountries()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerFindCountries$Response(params?: CommonControllerFindCountries$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: CountryResponse;
}>> {
    const obs = commonControllerFindCountries(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Restituisce l'elenco dei paesi.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `commonControllerFindCountries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  commonControllerFindCountries(params?: CommonControllerFindCountries$Params, context?: HttpContext): Observable<BaseResponse & {
'data'?: CountryResponse;
}> {
    const resp = this.commonControllerFindCountries$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<BaseResponse & {
'data'?: CountryResponse;
}>): BaseResponse & {
'data'?: CountryResponse;
} => r.body)
    );
  }

}
